<div height-100 flex-column flex class="ion-justify-content-between">
  <div>
    <app-sub-header-text title="{{'COMPONENTS.FORMS.IMMOBILE' | translate}}"
      subtitle="{{'COMPONENTS.FORMS.ADD_INFORMATIONS_AND_DESCRIPTION' | translate}}">
    </app-sub-header-text>
    <form max-width-form-web margin-auto [formGroup]="immobileForm">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col size="12" background-white-md-up>
          <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form-md-up>
            <!-- Observation -->
            <ion-col sizeXs="12" sizeXl="12" sizeSm="12" sizeMd="12" sizeLg="12">
              <ion-label color="primary-dark" position="stacked">{{'COMPONENTS.FORMS.REMARKS' | translate}}</ion-label>
              <angular-editor formControlName="surveyObservations" [config]="editorConfig"
                [placeholder]="'COMPONENTS.FORMS.ENTER_PROPERTY_NOTES' | translate" width-100 maxlength="3000" rows="5"
                class="padding-right-2x"></angular-editor>
              <div class="length-text"> {{ this.surveyObservations?.value?.length }} / 3000</div>
              <ion-note *ngIf="surveyObservations.hasError('maxlength') && (surveyObservations.dirty || surveyObservations.touched)" color="danger">
                {{ 'COMPONENTS.FORMS.MAX_LENGTH_EXCEEDED' | translate }}
              </ion-note>
            </ion-col>
            <!-- Description -->
            <ion-col sizeXs="12" sizeXl="12" sizeSm="12" sizeMd="12" sizeLg="12">
              <ion-label color="primary-dark" position="stacked">{{'COMPONENTS.FORMS.DESCRIPTION_OPTIONAL' | translate}}</ion-label>
              <angular-editor formControlName="surveyDescription" [config]="editorConfig"
                [placeholder]="'COMPONENTS.FORMS.ENTER_THE_ITEM_DESCRIPTION' | translate" width-100 maxlength="3000" rows="5"
                class="padding-right-2x"></angular-editor>
              <div class="length-text"> {{ this.surveyDescription?.value?.length }} / 3000</div>
              <ion-note *ngIf="surveyDescription.hasError('maxlength') && (surveyDescription.dirty || surveyDescription.touched)" color="danger">
                {{ 'COMPONENTS.FORMS.MAX_LENGTH_EXCEEDED' | translate }}
              </ion-note>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </form>
  </div>
  <div class="ion-padding ion-text-end" max-width>
    <ion-button class="ion-margin-start" responsive-button color="buttonPrimary" (click)="submit(immobileForm)">
      {{'COMPONENTS.FORMS.FINISH_PROPERTY' | translate}}
    </ion-button>
  </div>
</div>
